import { useEffect } from "react";
import { useRecoilState } from "recoil";
import {getCurriculumData, getCurriculumVersion, getHomeData} from "../network/Endpoint";
import {
    curriculumState, inAppCurriculumState,
    savedCurriculumVersionState,
    serverCurriculumVersionState
} from "../recoil/curriculums/curriculumState"; // Recoil 상태 import

// 서버에서 커리큘럼 버전 가져오기
const fetchServerVersion = async () => {
    try {
        const res = await getCurriculumVersion();
        const statusCode = res.data.status.code;
        if (statusCode === 'Success') {
            return res.data.data.version; // 서버에서 제공하는 최신 버전
        }
    } catch (error) {
        console.error("서버 버전 가져오기 실패:", error);
        return null;
    }
};


// 서버에서 커리큘럼 데이터 가져오기
const fetchCurriculumData = async () => {
    try {
        const res = await getCurriculumData();
        const statusCode = res.data.status.code;
        if (statusCode === 'Success') {
            return res.data.data; // 서버에서 제공하는 최신 버전
        }
    } catch (error) {
        console.error("커리큘럼 데이터 가져오기 실패:", error);
        return null;
    }
};

// 커리큘럼 업데이트 로직을 실행하는 커스텀 훅
export const useCurriculumUpdater = () => {
    const [savedVersion, setSavedVersion] = useRecoilState(savedCurriculumVersionState);
    const [savedCurriculum, setSavedCurriculum] = useRecoilState(curriculumState);
    const [savedInAppCurriculum, setSavedInAppCurriculum] = useRecoilState(inAppCurriculumState);
    const [serverVersion, setServerVersion] = useRecoilState(serverCurriculumVersionState);

    useEffect(() => {
        const updateCurriculum = async () => {
            const latestVersion = await fetchServerVersion();
            if (!latestVersion) return; // 서버에서 버전 정보를 가져오지 못하면 중단
            setServerVersion(latestVersion); // 서버 최신 버전 상태 업데이트
            if (savedVersion === latestVersion) {
                console.log("✅ 최신 버전과 동일하여 커리큘럼을 업데이트하지 않습니다.");
                return;
            }
            console.log("🔄 새로운 버전 감지됨! 커리큘럼 데이터 갱신 중...");
            const latestCurriculum = await fetchCurriculumData();

            if (latestCurriculum) {
                setSavedCurriculum(latestCurriculum); // 새로운 데이터 저장
                setSavedVersion(latestVersion); // 새로운 버전 정보 저장
                console.log("✅ 커리큘럼 데이터 및 버전 업데이트 완료!");
            }
        };

        updateCurriculum();
    }, []);
};
